module.exports = __webpack_public_path__ + "img/kp.0c0d354d.svg";